import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-neutral-900">{t('notFound.title')}</h1>
        <p className="text-neutral-600 mt-2">{t('notFound.description')}</p>
        <Link to="/" className="inline-block mt-4 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
          {t('notFound.backHome')}
        </Link>
      </div>
    </div>
  );
}
